import { useState, type FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { showToast, SpinAnimation } from "@twioku/common_components";
import { useRequireAgreedAnswerer } from "../features/answerer/hooks/useRequireAgreedAnswerer";
import { AddQuestionInput } from "../features/question/zod/AddQuestion";
import { useCreateUserQuestion } from "../features/question/hooks/useCreateUserQuestion";
import { Path } from "../routes/PagePath";
import { COMMON_ERROR_MESSAGE } from "../libs/constants";
import { QuestionForm } from "../features/question/components/QuestionForm";

export const CreateQuestionPage: FC = () => {
    const answererId = useParams().answererId as string;
    const { answerer, isLoading, isAgreed } =
        useRequireAgreedAnswerer(answererId);
    const { createUserQuestion } = useCreateUserQuestion();
    const navigate = useNavigate();
    const [isCreateLoading, setIsCreateLoading] = useState<boolean>(false);
    const handleClickAddQuestionButton = async (input: AddQuestionInput) => {
        setIsCreateLoading(true);
        await createUserQuestion.mutate(
            { answererId: input.answererId, title: input.title },
            {
                onSuccess: () => {
                    showToast("質問を追加しました");
                    navigate(`${Path.questionList}/${input.answererId}`, {
                        replace: true,
                    });
                },
                onError: () => {
                    showToast(COMMON_ERROR_MESSAGE, "error");
                },
                onSettled: () => {
                    setIsCreateLoading(false);
                },
            }
        );
    };

    if (isLoading) {
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <SpinAnimation />
            </div>
        );
    }

    if (!answerer || !isAgreed) {
        navigate(Path.notFound, { replace: true });
        return null;
    }

    return (
        <QuestionForm
            answerer={answerer}
            handleClickSaveQuestion={handleClickAddQuestionButton}
            saveQuestionButtonName="質問を追加する"
            isSaveLoading={isCreateLoading}
            mode="create"
        />
    );
};
